var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-card",
        {
          staticStyle: { "max-width": "1080px" },
          attrs: { "bg-variant": "light" },
        },
        [
          _c(
            "div",
            { staticClass: "chart-wrapper" },
            [
              _c("ApexPie", {
                attrs: {
                  type: "donut",
                  options: _vm.getOptions,
                  series: _vm.leaksFixed,
                  height: "310",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }